// @ts-nocheck
import {
    StoreMultipleSalesMessageStyle,
    storeMultipleSalesMessageStyle,
} from "@store/Library/Components/Foundation/StoreProduct/StoreProductMultipleSales";
import { InfosBoxStyles } from "@store/Library/Components/Toolkit/InfosBox";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import React, { FC } from "react";

const InfosBox = getWidgetComponent("InfosBox");

type StoreMinimumSalesMessageProps = {
    qty?: number;
    warning?: boolean;
    extendedStyles?: StoreMultipleSalesMessageStyle;
};

export interface StoreProductMultipleSalesStyle {
    infosBoxStyles?: InfosBoxStyles;
}

export const StoreMinimumSalesMessage: FC<StoreMinimumSalesMessageProps> = ({ warning, qty, extendedStyles }) => {
    const styles = React.useMemo(
        () => mergeToNew(storeMultipleSalesMessageStyle, extendedStyles),
        [storeMultipleSalesMessageStyle, extendedStyles],
    );
    const message = () => {
        return (
            <StyledWrapper {...styles.wrapper}>
                <Typography {...styles.message}>{`${translate(`MinimumSaleQty`)} ${qty}`}</Typography>
            </StyledWrapper>
        );
    };

    if (!qty || qty <= 1) {
        return null;
    }
    if (warning) {
        return <InfosBox type="default" size="tiny" content={message()} />;
    }
    return message();
};
export default StoreMinimumSalesMessage;
